// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Tab-module--cls1--3QovF","cls2":"styles-Tab-module--cls2--GKkFa styles-Tab-module--cls1--3QovF"};